    // 订阅脚本初始化
    var apiClient = null;
    if (window.ShopifyStorefrontAPIClient) {
        apiClient = ShopifyStorefrontAPIClient.createStorefrontApiClient({
        storeDomain: "vipbeauty-5864.myshopify.com",
        apiVersion: "2025-01",
        publicAccessToken: "856933f7ba5dbc3d5690894d4df82bca"
        });
    }

// fenqi
function openPopup(e) {
  	if( e == "paypal" ){
      jQuery('.pc_home_tanchuang-paypal').removeClass("hu_none");
            jQuery('.window-cover').show();
    }
}

function closePopup(e) {
  	if( e == "paypal" ){
      jQuery('.pc_home_tanchuang-paypal').addClass("hu_none");
    jQuery('.window-cover').hide();
    }
}